export default function AnnouncementInfo() {
  return (
    <div style={{ padding: 16 }}>
      <h3>About Announcements</h3>
      <p>This tile displays important church updates.</p>
    </div>
  );
}
